/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/TipEventArgs',[],function () {
	var TipEventArgs = function (tipId, args) {
		this.TipId = tipId;
		this.Args = args;
	};

	return TipEventArgs;
});
